export default __webpack_public_path__ + "static/media/OM.8700bcbf.svg";